module.exports = __webpack_public_path__ + "img/ELC_logo.675ef076.gif";